import { type SafeApply } from 'SafeApply';
import { type ReactRouterBridge } from 'Navigation/angularModule/scripts/react_router_bridge';
import { navigationHelper } from 'NavigationHelpers';

export default function navigateToAccountingOneStream($injector: angular.auto.IInjectorService) {
    const $rootScope = $injector.get('$rootScope');
    const reactRouterBridge = $injector.get<ReactRouterBridge>('reactRouterBridge');
    const safeApply = $injector.get('safeApply') as SafeApply;
    const { loadRoute } = navigationHelper();

    const path = '/course/50eeda2d-1b44-4a1d-b425-dead8982526f';
    if (reactRouterBridge.url() === path) {
        return Promise.resolve();
    }

    let cancelListener;
    const promise = new Promise(resolve => {
        cancelListener = $rootScope.$on('renderedStreamDashboard', resolve);
    });

    loadRoute(path);
    safeApply($rootScope);
    return promise.then(cancelListener);
}
